import { render, staticRenderFns } from "./CreatePlatformExportfileSendConfigComponent.vue?vue&type=template&id=d48ac72e&"
import script from "./CreatePlatformExportfileSendConfigComponent.vue?vue&type=script&lang=js&"
export * from "./CreatePlatformExportfileSendConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports